var exports = {
  "Yu": "readmeWrapper__4Y2qKJ",
  "IM": "readmeContainer__94FLoB",
  "iS": "readmeContainerWithToc__o-7iTb",
  "X4": "readmeContainerFull__hH63fu",
  "Qi": "readmeHeader__6X6KGc",
  "jq": "readmeHeading__foe77f",
  "rG": "readmeLink__PTIKYB",
};

module.exports = exports;
